module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "TOC"
    }
  }, [_c('h1', [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ded"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/003dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/004acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/006introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1"
    }
  }, [_vm._v("Great Beginnings")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec1"
    }
  }, [_vm._v("Bread with Gream Cheese and Pesto Spread")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec2"
    }
  }, [_vm._v("Antipasto Platter")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec3"
    }
  }, [_vm._v("Sun-dried Tomato Pesto on Crostini")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec4"
    }
  }, [_vm._v("Roasted Red Bell Pepper Crostini with Feta Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec5"
    }
  }, [_vm._v("Warm Brie with Marinated Roasted Red Peppers and Roasted Garlic")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec6"
    }
  }, [_vm._v("Party Cheese Ball")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec7"
    }
  }, [_vm._v("Beer Cheese Spread")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec8"
    }
  }, [_vm._v("Quesadillas")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec9"
    }
  }, [_vm._v("Fresh Tomato Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec10"
    }
  }, [_vm._v("Broiled Shrimp Rounds")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec11"
    }
  }, [_vm._v("Shrimp Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec12"
    }
  }, [_vm._v("Hot Shrimp Hors d’Oeuvre")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec13"
    }
  }, [_vm._v("Crab-filled Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec14"
    }
  }, [_vm._v("Grab for Crackers")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec15"
    }
  }, [_vm._v("Smoked Salmon Spread")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec16"
    }
  }, [_vm._v("Party Salmon Mousse")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec17"
    }
  }, [_vm._v("Sun-dried Tomato and Feta Cheese Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec18"
    }
  }, [_vm._v("Curried Seafood")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec19"
    }
  }, [_vm._v("Baked Black Bean Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec20"
    }
  }, [_vm._v("Chunky Guacamole")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec21"
    }
  }, [_vm._v("Hummus")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec22"
    }
  }, [_vm._v("Black Bean Nachos")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter1#sec23"
    }
  }, [_vm._v("Blue Cheese Meatballs")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2"
    }
  }, [_vm._v("Soup The Original Comfort Food")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#sec24"
    }
  }, [_vm._v("Cream of Mushroom Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#sec25"
    }
  }, [_vm._v("Garden-Tresh Tomato-Basil Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#sec26"
    }
  }, [_vm._v("Potato-Onion Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#sec27"
    }
  }, [_vm._v("Peanut Butter, Mushroom, and Broccoli Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#sec28"
    }
  }, [_vm._v("Curried Carrot Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#sec29"
    }
  }, [_vm._v("Country Vegetable Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#sec30"
    }
  }, [_vm._v("Dilled Zucchini Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#sec31"
    }
  }, [_vm._v("Real Chicken Noodle Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#sec32"
    }
  }, [_vm._v("Tomato, Corn, and Sausage Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#sec33"
    }
  }, [_vm._v("Navy Bean Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#sec34"
    }
  }, [_vm._v("Spicy Black Bean Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#sec35"
    }
  }, [_vm._v("Friday Clam Chowder")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#sec36"
    }
  }, [_vm._v("Northwest Seafood Chowder")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#sec37"
    }
  }, [_vm._v("Thick Spaghetti Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter2#sec38"
    }
  }, [_vm._v("Chilled Avocado Soup")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3"
    }
  }, [_vm._v("The Salad Bowl")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_39"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec39"
    }
  }, [_vm._v("Spinach, Pear, and Walnut Salad with Raspberry Vinaigrette")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec40"
    }
  }, [_vm._v("Greek Salad with Feta Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec41"
    }
  }, [_vm._v("Caesar Salad, San Francisco Style")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_42"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec42"
    }
  }, [_vm._v("Garden Salad with Variations")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_43"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec43"
    }
  }, [_vm._v("California Salad with Tarragon-Sesame Seed Dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_44"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec44"
    }
  }, [_vm._v("Mesclun Salad with Feta Cheese and Walnuts and Balsamic vinaigrette")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_45"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec45"
    }
  }, [_vm._v("Romaine-Bacon-Apple Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_46"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec46"
    }
  }, [_vm._v("Spinach Salad with Mushrooms Blue Cheese, and Bacon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_47a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec47a"
    }
  }, [_vm._v("Thick Tomato Slices with Avocado Dressing and Toasted Hazelnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_47"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec47"
    }
  }, [_vm._v("Avocado Mexican Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_48"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec48"
    }
  }, [_vm._v("Cashew Coleslaw")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_49"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec49"
    }
  }, [_vm._v("New Potato and Green Bean Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_50"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec50"
    }
  }, [_vm._v("Cucumber and Red Onion Salad with Dill Dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_51"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec51"
    }
  }, [_vm._v("Fresh Pea and Snap Pea Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_52"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec52"
    }
  }, [_vm._v("Vegetables Marinated with Fresh Herbs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_53"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec53"
    }
  }, [_vm._v("Spinach and Shrimp Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_54"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec54"
    }
  }, [_vm._v("Composed Salad with Shrimp, Mushrooms, and Sprouts")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_55"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec55"
    }
  }, [_vm._v("Greek Pasta Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_56"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec56"
    }
  }, [_vm._v("Couscous Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_57"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec57"
    }
  }, [_vm._v("Tortellini Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_58"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec58"
    }
  }, [_vm._v("Orange, Cucumber, and Jícama Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_59"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec59"
    }
  }, [_vm._v("Pear Salad with Blue Cheese Topping")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_60"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec60"
    }
  }, [_vm._v("Summer Fruit Platter with Curry Dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_61"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec61"
    }
  }, [_vm._v("Assorted Fruit with Honey-Yogurt Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_62"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter3#sec62"
    }
  }, [_vm._v("Metro Salad")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4"
    }
  }, [_vm._v("Poultry Plus")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_63"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#sec63"
    }
  }, [_vm._v("Orange-Hazelnut Chicken")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_64"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#sec64"
    }
  }, [_vm._v("Chicken Breasts with Spinach Filling and Cheese-Tarragon Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_65"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#sec65"
    }
  }, [_vm._v("Chicken Breasts Stuffed with Sun-Dried Tomatoes and Ricotta Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_66"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#sec66"
    }
  }, [_vm._v("Cajun Blackened Chicken Breasts")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_67"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#sec67"
    }
  }, [_vm._v("Chicken Breasts and Mushrooms with Rosemary and Mustard Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_68"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#sec68"
    }
  }, [_vm._v("Baked Tarragon Chicken Breasts")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_69"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#sec69"
    }
  }, [_vm._v("Baked Chicken Thighs with Lemon Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_70"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#sec70"
    }
  }, [_vm._v("Spanish Chicken with Olives")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_71"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#sec71"
    }
  }, [_vm._v("Oven-Barbecued Chicken with Bacon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_72"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#sec72"
    }
  }, [_vm._v("Baked Crunchy Coated Chicken")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_73"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#sec73"
    }
  }, [_vm._v("Greek-Style Roasted Whole Chicken")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_74"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#sec74"
    }
  }, [_vm._v("Family Night Chicken Stew")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_75"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#sec75"
    }
  }, [_vm._v("Chicken Roll-Ups, Mexican Style")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_76"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#sec76"
    }
  }, [_vm._v("Chicken, Black Bean, and Tortilla Casserole")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_77"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#sec77"
    }
  }, [_vm._v("Chicken and Vegetable Stir-try")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_78"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#sec78"
    }
  }, [_vm._v("Chicken Enchiladas")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_79"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#sec79"
    }
  }, [_vm._v("Make-Ahead Chicken or Turkey Casserole")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_80"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#sec80"
    }
  }, [_vm._v("Parmesan Cheese Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_81"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/010chapter4#sec81"
    }
  }, [_vm._v("Turkey Meatballs")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5"
    }
  }, [_vm._v("The Fish Market")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_82"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#sec82"
    }
  }, [_vm._v("Red Snapper with Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_83"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#sec83"
    }
  }, [_vm._v("Citrus Salmon Steaks")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_84a"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#sec84a"
    }
  }, [_vm._v("Baked Salmon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_84"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#sec84"
    }
  }, [_vm._v("Rémoulade Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_85"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#sec85"
    }
  }, [_vm._v("Sesame Snapper")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_86"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#sec86"
    }
  }, [_vm._v("Baked Halibut with Cashew-Crumb Topping")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_87"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#sec87"
    }
  }, [_vm._v("Baked Sole with Bacon Topping")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_88"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#sec88"
    }
  }, [_vm._v("Sole with Yogurt Topping")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_89"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#sec89"
    }
  }, [_vm._v("Broiled Swordfish with Fresh Peach-Avocado Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_90"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#sec90"
    }
  }, [_vm._v("Broiled Lemony Tuna with Pesto Mayonnaise")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_91"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#sec91"
    }
  }, [_vm._v("Herbed Tuna with Savory White Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_92"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#sec92"
    }
  }, [_vm._v("Tangy Baked Shrimp")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_93"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#sec93"
    }
  }, [_vm._v("Shrimp in Lime-Garlic Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_94"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#sec94"
    }
  }, [_vm._v("Shrimp, Scallop, and Mushroom Sauté")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_95"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#sec95"
    }
  }, [_vm._v("Spicy Seafood Stew")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_96"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#sec96"
    }
  }, [_vm._v("Crab and Shrimp Cakes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_97"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#sec97"
    }
  }, [_vm._v("Roasted Red Pepper Aïoli")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_98"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/011chapter5#sec98"
    }
  }, [_vm._v("Sautéed Almond Oysters with Two Sauces")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6"
    }
  }, [_vm._v("The Meat Market")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_99"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec99"
    }
  }, [_vm._v("Broiled New York Steak with Garlic Crumb Topping")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_100"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec100"
    }
  }, [_vm._v("Flank Dteak Stuffed with Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_101"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec101"
    }
  }, [_vm._v("Rolled Beef Roast with Onion Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_103"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec103"
    }
  }, [_vm._v("Prime Rib with Baked Mushroom Caps and Horseradish Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_104"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec104"
    }
  }, [_vm._v("Dijon Beef Tenderloin")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_105"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec105"
    }
  }, [_vm._v("Slow-baked Barbecued Beef Roast")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_106"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec106"
    }
  }, [_vm._v("Beef Brisket")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_107"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec107"
    }
  }, [_vm._v("Bloody Mary Beef Roast")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_108"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec108"
    }
  }, [_vm._v("Beer Beef Stew and Parslied Dumplings")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_110"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec110"
    }
  }, [_vm._v("Glazed Meat Loaf")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_112"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec112"
    }
  }, [_vm._v("Coffee Beef Stew")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_113"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec113"
    }
  }, [_vm._v("Chile Meatballs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_114"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec114"
    }
  }, [_vm._v("Chili with Toppings")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_116"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec116"
    }
  }, [_vm._v("Party Spaghetti and Meatballs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_117"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec117"
    }
  }, [_vm._v("Rack of Lamb")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_118"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec118"
    }
  }, [_vm._v("Tzatziki (Greek Cucumber-yogurt Dip)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_119"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec119"
    }
  }, [_vm._v("Broiled Lamb Chops with Dijon-Mayonnaise Topping")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_120"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec120"
    }
  }, [_vm._v("Pork Chops in Sour Cream Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_121"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec121"
    }
  }, [_vm._v("Herbed Pork Loin with Roasted Potatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_122"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec122"
    }
  }, [_vm._v("Company Pork Chops")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_123"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/012chapter6#sec123"
    }
  }, [_vm._v("Mexican Pork Roast")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7"
    }
  }, [_vm._v("The Vegetable Stand")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_124"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec124"
    }
  }, [_vm._v("Fresh Asparagus and Red Pepper with Wine Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_125"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec125"
    }
  }, [_vm._v("Beets in Raspberry Vinegar Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_126"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec126"
    }
  }, [_vm._v("Orange Broccoli")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_127"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec127"
    }
  }, [_vm._v("Steamed Broccoli and Cauliflower with Walnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_128"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec128"
    }
  }, [_vm._v("Tomato-Broccoli Cups")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_129"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec129"
    }
  }, [_vm._v("Lemony Green Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_130"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec130"
    }
  }, [_vm._v("Braised Cabbage with Apples")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_131"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec131"
    }
  }, [_vm._v("Honey-Butter Carrots")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_132"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec132"
    }
  }, [_vm._v("Minted Carrots")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_133"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec133"
    }
  }, [_vm._v("Steamed Carrots and Zucchini Strips")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_134"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec134"
    }
  }, [_vm._v("Sauté of Summer Peas and Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_135"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec135"
    }
  }, [_vm._v("Roasted Vegetables")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_136"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec136"
    }
  }, [_vm._v("Plank Potatoes with Parmesan Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_137"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec137"
    }
  }, [_vm._v("Roasted New Potatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_138"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec138"
    }
  }, [_vm._v("Baked Potato Strips with Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_139"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec139"
    }
  }, [_vm._v("Super Spuds with Toppings")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_140"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec140"
    }
  }, [_vm._v("Scalloped Potatoes with Red Pepper")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_141"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec141"
    }
  }, [_vm._v("Whipped Potatoes with Carrots and Garlic")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_142"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec142"
    }
  }, [_vm._v("Potato Pancakes")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_143"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec143"
    }
  }, [_vm._v("New Potato and Blue Cheese Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_144"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec144"
    }
  }, [_vm._v("Sweet Onion and Rice Bake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_145"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec145"
    }
  }, [_vm._v("Steamed Spinach and Garlic")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_146"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec146"
    }
  }, [_vm._v("Broiled Tomato Slices")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_147"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec147"
    }
  }, [_vm._v("Summer time Casserole")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_148"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec148"
    }
  }, [_vm._v("Vegetable and Fresh Herb Casserole")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_149"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/013chapter7#sec149"
    }
  }, [_vm._v("Greek Zucchini Pancakes")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8"
    }
  }, [_vm._v("Pasta")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_150"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec150"
    }
  }, [_vm._v("Seafood and Mushroom Pasta with Basil Pesto")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_151"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec151"
    }
  }, [_vm._v("Pasta and Thick Tomato Sauce with Basil and Pine Nuts")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_152"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec152"
    }
  }, [_vm._v("Pasta with Roasted Veqetables")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_153"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec153"
    }
  }, [_vm._v("Vermicelli and Sausage")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_154"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec154"
    }
  }, [_vm._v("Pasta with Red Bell Pepper, Mushrooms, and Zucchini")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_155"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec155"
    }
  }, [_vm._v("Angel Hair Pasta with Gorgonzola Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_156"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec156"
    }
  }, [_vm._v("Chicken, Mushrooms, Tomatoes and Linguini")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_157"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec157"
    }
  }, [_vm._v("Acini di Pepe and Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_158"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec158"
    }
  }, [_vm._v("Orzo with Parmesan Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_159"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec159"
    }
  }, [_vm._v("Pasta and Grain Pilaf")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_160"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec160"
    }
  }, [_vm._v("Bulgur and Almond Pilaf")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_161"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec161"
    }
  }, [_vm._v("Couscous with Pine Nuts")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_162"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec162"
    }
  }, [_vm._v("Pink Rice")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_163"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec163"
    }
  }, [_vm._v("Rice and Mushroom Pilaf")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_164"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec164"
    }
  }, [_vm._v("Orange, Rice, and Barley Pilaf")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_165"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec165"
    }
  }, [_vm._v("Basmati Rice with Nuts and spices")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_166"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec166"
    }
  }, [_vm._v("Wild Rice Plus")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_167"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec167"
    }
  }, [_vm._v("Asian Rice")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_168"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec168"
    }
  }, [_vm._v("Savory Brown Rice")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_169"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec169"
    }
  }, [_vm._v("Corn-Chile-Rice Casserole")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_170"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec170"
    }
  }, [_vm._v("Basic Polenta")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_171"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/014chapter8#sec171"
    }
  }, [_vm._v("Corn and Black Bean Polenta")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9"
    }
  }, [_vm._v("Great on the Grill")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_172"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec172"
    }
  }, [_vm._v("New York Steaks with Sautéed Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_173"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec173"
    }
  }, [_vm._v("Marinated Flank Steak")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_174"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec174"
    }
  }, [_vm._v("Bourbon Beef Tanderloin with Grilled Tomato Halves")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_175"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec175"
    }
  }, [_vm._v("Beef and Vegetable Kabobs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_176"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec176"
    }
  }, [_vm._v("Beef Roast on the Grill")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_177"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec177"
    }
  }, [_vm._v("Mexican-Style Pork Tenderloin")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_178"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec178"
    }
  }, [_vm._v("Dijon Pork Chops")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_179"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec179"
    }
  }, [_vm._v("Grilled Pork Chops with Honey Glaze")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_180"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec180"
    }
  }, [_vm._v("Hawaiian Pork Loin Roast")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_181"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec181"
    }
  }, [_vm._v("Barbecued Ribs with Dry Rub and Beer Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_182"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec182"
    }
  }, [_vm._v("Orange-Thyme Lamb Chops")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_183"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec183"
    }
  }, [_vm._v("Grilled Butterflied Leg of Lamb with Mint Pesto")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_184"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec184"
    }
  }, [_vm._v("Lamb and Vegetable Kabobs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_185"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec185"
    }
  }, [_vm._v("Grilled Drumsticks with Zesty Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_186"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec186"
    }
  }, [_vm._v("Soy-Sesame Chicken Breasts")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_187"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec187"
    }
  }, [_vm._v("Chicken with Tangy Yogurt Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_188"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec188"
    }
  }, [_vm._v("Hot or cold Chicken Thighs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_189"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec189"
    }
  }, [_vm._v("Grilled Turkey Breast with Herb Baste")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_190"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec190"
    }
  }, [_vm._v("Mixed Grill")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_191"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec191"
    }
  }, [_vm._v("Oriental Halibut Steaks")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_192"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec192"
    }
  }, [_vm._v("Shrimp, Scallop, and Vegetable Kabobs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_193"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec193"
    }
  }, [_vm._v("Halibut with Yogurt-Cucumber-Dill Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_194"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec194"
    }
  }, [_vm._v("Grilled Salmon Fillets with Fruit Kabobs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_195"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/015chapter9#sec195"
    }
  }, [_vm._v("Grilled Corn on the Cob")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "ch10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10"
    }
  }, [_vm._v("Great Endings")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_196"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec196"
    }
  }, [_vm._v("Fresh Peach Crisp")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_197"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec197"
    }
  }, [_vm._v("Spiced Apple Crisp")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_198"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec198"
    }
  }, [_vm._v("Blueberry-Cranberry Crisp")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_199"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec199"
    }
  }, [_vm._v("Blueberry Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_200"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec200"
    }
  }, [_vm._v("Deep-dish Berry Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_201"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec201"
    }
  }, [_vm._v("Rhubarb Crumble")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_202"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec202"
    }
  }, [_vm._v("Sour Cream Lemon Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_203"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec203"
    }
  }, [_vm._v("Chocolate Fudge Pie with Hazelnut Whipped Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_204"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec204"
    }
  }, [_vm._v("Flan (Crème Caramel)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_205"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec205"
    }
  }, [_vm._v("Apricot and Blueberry Flan")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_206"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec206"
    }
  }, [_vm._v("Hazelnut Cheesecake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_207"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec207"
    }
  }, [_vm._v("Fresh Pear-Walnut Torte")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_208"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec208"
    }
  }, [_vm._v("Kahlúa Chocolate Ice Cream Torte")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_209"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec209"
    }
  }, [_vm._v("Filled Pumpkin Dessert")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_210"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec210"
    }
  }, [_vm._v("Fruit Trifle")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_211"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec211"
    }
  }, [_vm._v("Strawberry Shortcake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_212"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec212"
    }
  }, [_vm._v("Citrus-Nut Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_213"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec213"
    }
  }, [_vm._v("Buttermilk Chocolate Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_214"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec214"
    }
  }, [_vm._v("Grandma’s Coffee Grumb Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_215"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec215"
    }
  }, [_vm._v("Cashew Brownies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_216"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec216"
    }
  }, [_vm._v("Old-fashioned Icebox Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_217"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec217"
    }
  }, [_vm._v("Lemon Drop Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_218"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec218"
    }
  }, [_vm._v("Frosted Chocolate Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_219"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec219"
    }
  }, [_vm._v("Toffee Nut Bars")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_220"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec220"
    }
  }, [_vm._v("Granberry Sorbet")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_221"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec221"
    }
  }, [_vm._v("Fresh Pear Sorbet")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "sec_222"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/016chapter10#sec222"
    }
  }, [_vm._v("All-Purpose Berry Sauces")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "index"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/017index"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent",
    attrs: {
      "id": "table"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/018tableofequivalents"
    }
  }, [_vm._v("Table of Equivalents")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/019abouttheauthor"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/021copyright"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24ba5d4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005-toc.vue
// module id = 69
// module chunks = 0